import { render, staticRenderFns } from "./StorageBinPage.vue?vue&type=template&id=9f490ac2&scoped=true&"
import script from "./StorageBinPage.vue?vue&type=script&lang=js&"
export * from "./StorageBinPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f490ac2",
  null
  
)

export default component.exports